import { render, staticRenderFns } from "./ChoosePlan.vue?vue&type=template&id=1697d4dc&scoped=true"
import script from "./ChoosePlan.vue?vue&type=script&lang=js"
export * from "./ChoosePlan.vue?vue&type=script&lang=js"
import style0 from "./ChoosePlan.vue?vue&type=style&index=0&id=1697d4dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1697d4dc",
  null
  
)

export default component.exports